const scaler = (originalSize: number, newSize: number): number => newSize / originalSize;

export default scaler;
